$ = require 'jquery'
Accounts = require 'lib/accounts'
AjaxPromise = require 'network/ajax-promise'
Auth = require 'db/auth'
ChangeAdditionalDetailsView = require 'views/billing/change-additional-details-view'
ChangeBillingInfoView = require 'views/billing/change-billing-info-view'
ChangeCreditCardView = require 'views/billing/change-credit-card-view'
Confirm = require 'views/lib/confirm'
Controller = require 'controller'
CreditCardFormComponent = require 'views/billing/credit-card-form-component'
CreditCardComponent = require 'views/billing/form-sections/credit-card-component'
AddressTaxComponent = require 'views/billing/form-sections/address-tax-component'
GoldFromBcInfoComponent = require 'views/billing/gold-from-bc-info-component'
SummaryComponent = require 'views/billing/form-sections/summary-component'
TermsOfServiceComponent = require 'views/billing/form-sections/terms-of-service-component'
ProductsComponent = require 'views/billing/form-sections/products-component'
MemberFeatures = require 'data/member-features'
MemberGoldView = require 'views/member/member-gold-view'
MemberView = require 'views/member/member-view'
ModelLoader = require 'db/model-loader'
PaidAccount = require 'network/paid-account'
PaidProductBannerComponent = require 'views/ads/paid-product-banner-component'
PopOver = require 'views/lib/pop-over'
BillingComponent = require 'views/billing/billing-component'
React = require 'react'
ReactDOM = require 'react-dom'
ReactRootComponent = require 'views/internal/react-root-component'
billingDataFromModel = require 'views/billing/internal/billing-data-from-model'
l = require 'lib/localize'
f = require 'effing'
moment = require 'moment'
partialComponent = require 'lib/react/partial-component'
templates = require 'views/internal/templates'
track = require 'debug/track'
recup = require 'recup'

module.exports = class MemberBillingView extends MemberView
  renderMainContent: ->
    track("Member Billing Page", "Open")

    @$('.js-content').empty()

    @$reactRoot ?= $('<div></div>')
    @$('.js-content').append(@$reactRoot)
    @renderReactSection()

    @setActiveView('.js-billing')

    @renderGoldView()

    @

  renderReactSection: ->
    ReactDOM.render(@getReactRoot(), @$reactRoot[0])

    @

  getReactRoot: ->
    React.createElement ReactRootComponent, {},
      if @hasGoldFromBc()
        @getGoldFromBcInfoComponent()
      else if @hasPaidAccount()
        @getBillingComponent()
      else
        @getSignUpForGoldComponent()

  hasGoldFromBc: ->
    MemberFeatures.getProductNumber('trelloGoldFromBC') in @model.get('products') &&
    @model.hasBCPowerUps()

  hasPaidAccount: ->
    Accounts.hasAccount(@model.get('paidAccount')?.standing)

  getGoldFromBcInfoComponent: ->
    recup.render => recup.div =>
      recup.createElement GoldFromBcInfoComponent,
        hasPaidAccount: @hasPaidAccount()
        organizationList: @model.organizationList

  getBillingComponent: ->
    data = billingDataFromModel @model, MemberFeatures,
      type: 'gold'
      productName: l 'products.gold'
      productIconClass: 'trello-gold'
      detailsUrl: '/gold'

      onRenewClick: f(@, 'renew')
      cancelProduct: f(@, 'cancel')
      onSwitchToYearly: f(@, 'switchToYearly')

      didntGetAuthStatus: =>
        ModelLoader.loadMemberAccountData @model.get('username')
        .done()

      didGetAuthStatus: =>
        ModelLoader.loadMemberAccountData @model.get('username')
        .done()

      onChangeBillingContactClick: f(@, 'changeBillingContactPopover')
      reactivateProduct: f(PaidAccount, 'reactivate', @model)
      changeCreditCard: f(PaidAccount, 'changeCreditCard', @model)
      createPaidAccount: f(PaidAccount, 'createAccount', @model)
      paidAccountPoll: f(AjaxPromise, url: "#{ @model.urlRoot }/#{ @model.id }?paid_account=true")
      onClickChangeCC: f(@, 'changeCreditCardPopover')
      onChangeAdditionalDetailsClick: f(@, 'changeAdditionalDetailsPopover')

    React.createElement BillingComponent, data

  getSignUpForGoldComponent: ->
    recup.render => recup.div =>
      recup.createElement PaidProductBannerComponent,
        stringsKey: 'gold'
        subtitleCount: 1
        infoUrl: '/gold'
        epilogueCount: 0
        icon: 'trello-gold'

      current = MemberFeatures.currentPriceObjectForModel(@model)
      recup.div '.billing', =>
        recup.createElement CreditCardFormComponent,
          defaultProduct: current.yearly.productNumber
          monthlyProduct: current.monthly
          yearlyProduct: current.yearly
          onSubmit: f(PaidAccount, 'createAccount', @model)
          doPoll: f(AjaxPromise, url: "#{ @model.urlRoot }/#{ @model.id }?paid_account=true")
          buttonKey: 'upgrade-me'
          contentBuilders: [
            partialComponent ProductsComponent,
              productName: "Trello Gold"
              monthlyProduct: current.monthly
              yearlyProduct: current.yearly
              defaultProduct: current.yearly.productNumber
              billingStrategy: current.billingStrategy
            partialComponent CreditCardComponent
            partialComponent AddressTaxComponent
            partialComponent SummaryComponent,
              monthlyProduct: current.monthly
              yearlyProduct: current.yearly
              defaultProduct: current.yearly.productNumber
              billingStrategy: current.billingStrategy
            partialComponent TermsOfServiceComponent
          ]
          extraData:
            billingContactFullName: @model.get('paidAccount')?.contactFullName ? Auth.me().get('fullName')
            billingContactEmail: @model.get('paidAccount')?.contactEmail ? Auth.me().get('email')
            billingContactLocale: @model.get('paidAccount')?.contactLocale ? Auth.me().getPref('locale')
          didntGetAuthStatus: =>
            ModelLoader.loadMemberAccountData @model.get('username')
            .done()
          didGetAuthStatus: =>
            Controller.memberBoardsView()

  renderGoldView: ->
    if @hasGoldFromBc()
      return @

    @$('.js-content').prepend(@subview(MemberGoldView, @model, { allowDismiss: false }).render().el)

    @

  cancel: ->
    track("Member View", "Billing Page", "Cancel Gold")

    PaidAccount.cancel(@model)
    .then (res) =>
      track("Member", "Successfully Canceled Paid Account")
      @model.set(res)

  renew: ->
    track("Member View", "Billing Page", "Renew Expiring Gold Subscription")

    PaidAccount.renew(@model)
    .then (res) =>
      track("Member", "Successfully Renewed Expiring Yearly Gold Subscription")
      @model.set(res)

  switchToYearly: (el) ->
    Confirm.toggle 'yearly billing switch',
      elem: el
      model: @model
      confirmBtnClass: 'primary'
      fxConfirm: (e) =>
        PaidAccount.changeProduct(@model, MemberFeatures.currentProducts.yearly)
        .then (res) =>
          track("Organization", "Successfully Switched Business Class to Yearly Billing")
          @model.set(res)
        .done()

  changeBillingContactPopover: (el) ->
    track("Member View", "Billing Page", "Open Change Billing Contact Info")

    PopOver.toggle
      elem: el
      view: new ChangeBillingInfoView({ @model, @modelCache })

  changeCreditCardPopover: (el) ->
    track("Member View", "Billing Page", "Open Change Credit Card")

    PopOver.toggle
      elem: el
      view: new ChangeCreditCardView({ @model, @modelCache })

  changeAdditionalDetailsPopover: (el) ->
    track("Member View", "Billing Page", "Open Change Additional Details")

    PopOver.toggle
      elem: el
      view: new ChangeAdditionalDetailsView({ @model, @modelCache })

  remove: ->
    ReactDOM.unmountComponentAtNode(@$reactRoot[0])
    super



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-billing-view.coffee